// Parses a poseidon version string like "0.11.0" into [major, minor, patch].
// Returns null for missing / unparseable input (incl. "Unknown", placeholders).
const parsePoseidonVersion = (versionStr) => {
  if (!versionStr) return null;
  const parts = String(versionStr).trim().split('.').slice(0, 3).map((p) => parseInt(p, 10));
  if (parts.some(Number.isNaN)) return null;
  while (parts.length < 3) parts.push(0);
  return parts;
};

// Returns true when the parsed version is at least [maj, min, patch].
const poseidonAtLeast = (versionStr, [maj, min = 0, patch = 0]) => {
  const v = parsePoseidonVersion(versionStr);
  if (!v) return false;
  if (v[0] !== maj) return v[0] > maj;
  if (v[1] !== min) return v[1] > min;
  return v[2] >= patch;
};

export const supportsModelUpload = (poseidonVersion) =>
  poseidonAtLeast(poseidonVersion, [0, 11, 0]);

export const supportsSpeedTest = (poseidonVersion) =>
  poseidonAtLeast(poseidonVersion, [0, 11, 0]);
